/**
 * @desc 入库单明细
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inDetail.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/inDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
